import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { BsFillArrowUpCircleFill } from 'react-icons/bs';
import { Link } from 'react-scroll';

export default function BackToTop() {
    const [isvisible, setIsvisible] = useState(false);

    const toggleVisibility = () => {
        if (window.pageYOffset > 200) {
            setIsvisible(true);
        }
        else {
            setIsvisible(false);
        }
    }
    useEffect(() => {
        window.addEventListener("scroll", toggleVisibility);
    }, [])
    return (
        <Wrapper>
            {
                isvisible && <Link to='home' spy={true} offset={-50} duration={500} smooth={true}><BsFillArrowUpCircleFill /></Link>
            }
        </Wrapper>
    )
}

const Wrapper = styled.div`
width: 4rem;
height: 4rem;
position: fixed;
bottom:5%;
right:5%;
display: flex;
justify-content: center;
align-items: center;
border-radius: 50%;
overflow: hidden;
cursor: pointer;
a{
    width: 100%;
    height: 100%;
    svg{
        width:100%;
        height: 100%;
        color: var(--section-color);
        background-color: white;
        border-radius: 50%;
        transition: all .3s ease-in-out;
        &:hover{
            transform: scale(1.2);
        }
    }
}
`